import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ThemeConstantService } from "../../services/theme-constant.service";
import { AccountService, EventManager, IUser } from "../../../core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { LoginService } from "../../../core/services";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { HttpResponse } from "@angular/common/http";
import { AppQueries } from "src/app/state";
import { distinctUntilChanged, filter, map, Observable, startWith } from "rxjs";
import { IBreadcrumb } from "../../interfaces/breadcrumb.type";
declare let $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  breadcrumbs$: Observable<IBreadcrumb[]>;

  searchVisible = false;
  quickViewVisible = false;
  isFolded: boolean;
  isExpand: boolean;
  accountInfo: any;
  theme: string = "primary";
  dynamicColor: {
    color: string;
    color1: string;
    color2: string;
    color3: string;
    color4: string;
    color5: string;
  } = { color: "", color1: "", color2: "", color3: "", color4: "", color5: "" };
  selectedColor: string = "";
  cssContent: string = "";
  variableFields: any = {};
  color: any;
  isHide: boolean = false;
  isSaleLead: boolean = false;
  domain: string = "";
  tab: string = "FMARKET"; // LIFE_HERO, FMARKET
  constructor(
    private themeService: ThemeConstantService,
    private loginService: LoginService,
    private $localStorage: LocalStorageService,
    private accountService: AccountService,
    private sessionStorageService: SessionStorageService,
    private eventManager: EventManager,
    private appQueries: AppQueries,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.breadcrumbs$ = this.router.events.pipe(
      startWith(new NavigationEnd(0, "/", "/")),
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
      map((data) => this.buildBreadCrumb(this.activatedRoute.root)),
    );
    this.accountInfo =
      this.accountInfo ||
      this.sessionStorageService.retrieve("USER_PROFILE") ||
      {};
    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded),
    );
    this.themeService.isExpandChanges.subscribe(
      (isExpand) => (this.isExpand = isExpand),
    );
    this.eventManager.subscribe("change-crm", (res) => {
      this.domain = res.content.tab;
      if (this.domain === "LIFE_HERO") {
        this.changeTheme("lifehero");
      } else this.changeTheme("primary");
    });
    this.appQueries.userProfile$.subscribe((userProfile) => {
      this.accountInfo = userProfile || {};
      this.isSaleLead = this.accountInfo.isSaleLead;
      if (!this.isSaleLead) {
        this.changeTab('FMARKET');
      }
    });
    this.theme = this.$localStorage.retrieve("theme");
    if (this.theme === "lifehero") {
      this.tab = "LIFE_HERO";
    }
  }
  private buildBreadCrumb(
    route: ActivatedRoute,
    url: string = "",
    breadcrumbs: IBreadcrumb[] = [],
  ): IBreadcrumb[] {
    let label = "",
      path = "/";
    const display = null;

    if (route.routeConfig) {
      if (route.routeConfig.data) {
        label = route.routeConfig.data.title;
        path += route.routeConfig.path;
      }
    } else {
      label = "Dashboard";
      path += "dashboard";
    }

    const nextUrl = path && path !== "/dashboard" ? `${url}${path}` : url;
    const breadcrumb = {
      label,
      url: nextUrl,
    } as IBreadcrumb;

    const newBreadcrumbs = label
      ? [...breadcrumbs, breadcrumb]
      : [...breadcrumbs];
    if (route.firstChild) {
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
  ngAfterViewInit(): void {
    this.setUpDynamic();
    // this.changeTab('LIFE_HERO');
  }
  setUpDynamic() {
    this.variableFields = this.$localStorage.retrieve("variable_theme");
    if (!this.variableFields) {
      return;
    }
    this.dynamicColor.color =
      this.variableFields[`${"dynamic-theme-main-color"}`];
    this.dynamicColor.color1 = this.variableFields[`${"dynamic-theme-color"}`];
    this.dynamicColor.color2 =
      this.variableFields[`${"dynamic-theme-color-2"}`];
    this.dynamicColor.color3 =
      this.variableFields[`${"dynamic-theme-color-3"}`];
    this.dynamicColor.color4 =
      this.variableFields[`${"dynamic-theme-color-4"}`];
    this.dynamicColor.color5 =
      this.variableFields[`${"dynamic-theme-color-5"}`];
  }
  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }

  isAuthenticated() {
    return this.accountService.isAuthenticated();
  }

  logout() {
    this.loginService.logout();
    this.router.navigate(["/authentication/login"]);
  }
  changeTheme(theme) {
    this.theme = theme;
    this.eventManager.broadcast({
      name: "change-theme",
      content: {
        theme,
      },
    });
    setTimeout(() => {
      this.setUpDynamic();
    }, 1000);
  }
  changeColor(selectedColor) {
    switch (selectedColor) {
      case "color":
        document.documentElement.style.setProperty(
          `--dynamic-theme-main-color`,
          this.dynamicColor.color,
        );
        this.$localStorage.store(
          "dynamic-theme-main-color",
          this.dynamicColor.color,
        );
        break;
      case "color1":
        document.documentElement.style.setProperty(
          `--dynamic-theme-color`,
          this.dynamicColor.color1,
        );
        this.$localStorage.store(
          "dynamic-theme-color",
          this.dynamicColor.color1,
        );
        break;
      case "color2":
        document.documentElement.style.setProperty(
          `--dynamic-theme-color-2`,
          this.dynamicColor.color2,
        );
        this.$localStorage.store(
          "dynamic-theme-color-2",
          this.dynamicColor.color2,
        );
        break;
      case "color3":
        document.documentElement.style.setProperty(
          `--dynamic-theme-color-3`,
          this.dynamicColor.color3,
        );
        this.$localStorage.store(
          "dynamic-theme-color-3",
          this.dynamicColor.color3,
        );
        break;
      case "color4":
        document.documentElement.style.setProperty(
          `--dynamic-theme-color-4`,
          this.dynamicColor.color4,
        );
        this.$localStorage.store(
          "dynamic-theme-color-4",
          this.dynamicColor.color4,
        );
        break;
      case "color5":
        document.documentElement.style.setProperty(
          `--dynamic-theme-color-5`,
          this.dynamicColor.color5,
        );
        this.$localStorage.store(
          "dynamic-theme-color-5",
          this.dynamicColor.color5,
        );
        break;
    }
  }
  hideTheme() {
    this.isHide = true;
  }
  showTheme() {
    this.isHide = false;
  }
  changeTab(tab) {
    this.tab = tab;
    this.eventManager.broadcast({
      name: "change-crm",
      content: {
        tab,
      },
    });
  }
  back() {
    window.history.back();
  }
}
